var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"mt-4"},[_c('v-fade-transition',[(_vm.loading)?_c('div',[_vm._v(" Schreibt "),_c('span',{attrs:{"id":"loadingAnimation"}},[_vm._v(".")])]):_vm._e()])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }